// Brand lockup for inkedform. Inline SVG (no external file) so it always
// renders — a missing or broken logo.png previously left a blank square.

export function BrandIcon({ size = 32, box = true }) {
  const glyph = (
    <>
      <path
        d="M13.5 6.5h10a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-10"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
      />
      <path
        d="M18.5 4.5l5 5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.9"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5 13.5h7M15.5 17.5h5"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.7"
        strokeLinecap="round"
        opacity="0.85"
      />
      <path
        d="M6.5 12.5l2.2 2.2 4-4"
        fill="none"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </>
  );

  if (!box) {
    return (
      <svg width={size} height={size} viewBox="0 0 32 32" fill="none" aria-hidden="true" style={{ display: 'block' }}>
        {glyph}
      </svg>
    );
  }

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 40 40"
      fill="none"
      aria-hidden="true"
      style={{ display: 'block', flexShrink: 0 }}
    >
      <rect width="40" height="40" rx="9" fill="url(#fp-g)" />
      <defs>
        <linearGradient id="fp-g" x1="0" y1="0" x2="40" y2="40" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#0e7c8c" />
          <stop offset="1" stopColor="#16c1d5" />
        </linearGradient>
      </defs>
      <g transform="translate(4 4)" color="#fff">
        {glyph}
      </g>
    </svg>
  );
}

export default function BrandMark({ compact = false, light = false, size = 30 }) {
  const color = light ? '#ffffff' : 'var(--company-primary-color, #16c1d5)';
  const sub = light ? 'rgba(255,255,255,0.65)' : '#6b7280';

  return (
    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 10, minWidth: 0 }}>
      <BrandIcon size={size} />
      {!compact && (
        <span style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.15, minWidth: 0 }}>
          <span
            style={{
              fontSize: 15,
              fontWeight: 700,
              color,
              letterSpacing: '0.2px',
              whiteSpace: 'nowrap',
            }}
          >
            inkedform
          </span>
          <span
            style={{
              fontSize: 11,
              fontWeight: 500,
              color: sub,
              letterSpacing: '0.4px',
              textTransform: 'uppercase',
              whiteSpace: 'nowrap',
            }}
          >
            PDF Form Studio
          </span>
        </span>
      )}
    </span>
  );
}

